module.exports = __webpack_public_path__ + "static/greens-acorn-1b9c0ff4b3417311a0b46063c35ca36f.jpg";